module.exports = __webpack_public_path__ + "static/img/3_5_1.37cd0eb1.jpg";